export enum LimitedAccessVerificationMethod {
  Email = 'EMAIl',
  CardCode = 'CARD_CODE',
}

export interface LimitedAccessVerificationFormPayload {
  method: LimitedAccessVerificationMethod;
}

export enum LimitedAccessVerificationStep {
  SelectMethod = 'SELECT_METHOD',
  Email = 'EMAIL',
}

export enum VerificationSuccessVariants {
  Activated = 'ACTIVATED',
  Error = 'Error',
}
